let loginIcon = null; // Global declaration, initialized once
let supabaseClient; // Declare globally
const isDev = window.location.hostname === 'localhost';
const projectClickHandlers = new Map(); // Track click handlers globally
let highlightApplied = false; // Add flag to track highlight completion
document.addEventListener('DOMContentLoaded', async ()=>{
    if (isDev) console.log("Starting initializeApp...");
    if (typeof supabase === 'undefined') {
        console.error("Supabase SDK not loaded yet");
        await new Promise((resolve)=>{
            const script = document.querySelector('script[src*="supabase-js"]');
            script.addEventListener('load', resolve);
        });
    }
    supabaseClient = supabase.createClient(process.env.SUPABASE_URL, process.env.SUPABASE_ANON_KEY);
    if (isDev) console.log("Supabase initialized");
    await initializeApp(supabaseClient);
});
async function initializeApp(supabase1) {
    const darkModeToggle = document.getElementById('dark-mode-toggle');
    const body = document.body;
    const contentWrapper = document.querySelector('.content-wrapper');
    const collaborateSection = document.querySelector('.collaborate-section');
    const adminControls = document.getElementById('admin-controls');
    const loginForm = document.getElementById('login-form');
    let logoutBtn = document.getElementById('logout-btn'); // Define logoutBtn here
    setupDarkMode(darkModeToggle, body);
    setupScrollEffects(collaborateSection);
    // Initialize login icon only once
    if (!loginIcon) {
        loginIcon = document.createElement('div');
        loginIcon.className = 'login-icon';
        loginIcon.innerHTML = '<i class="fas fa-user-lock"></i>';
        loginIcon.style.position = 'absolute';
        loginIcon.style.top = '20px';
        loginIcon.style.right = '120px';
        loginIcon.style.fontSize = '19px';
        loginIcon.style.cursor = 'pointer';
        loginIcon.style.transition = 'transform 0.3s ease, color 0.3s ease';
        loginIcon.style.zIndex = '1000';
        document.querySelector('header').appendChild(loginIcon);
        if (isDev) console.log("Login icon appended:", loginIcon);
        // Attach listener with debug log
        loginIcon.addEventListener('click', async (event)=>{
            event.stopPropagation();
            if (isDev) console.log("Login icon clicked");
            const { data: session } = await supabase1.auth.getSession();
            if (!session?.user) {
                window.location.hash = '#admin';
                loginForm.style.display = 'flex';
                contentWrapper.classList.add('blur');
                body.classList.add('modal-open');
                document.body.style.overflow = 'hidden';
                document.body.style.height = '100vh';
            } else if (isDev) console.log("Lock icon clicked but user is already logged in; no action taken.");
        });
        if (isDev) console.log("Login icon listener attached");
    }
    // Get the initial session synchronously
    const { data: initialSession } = await supabase1.auth.getSession();
    let user = initialSession?.user;
    let isAdmin = false;
    if (user) {
        const { data: userProfile } = await supabase1.from('users').select('is_admin').eq('id', user.id).single();
        isAdmin = userProfile?.is_admin;
    }
    if (isDev) console.log("Initial User:", user, "isAdmin:", isAdmin);
    // Set initial UI state
    if (user) {
        adminControls.style.display = isAdmin ? 'block' : 'none';
        loginForm.style.display = 'none';
        contentWrapper.classList.remove('blur');
        body.classList.remove('modal-open');
        document.body.style.overflow = 'auto';
        document.body.style.height = 'auto';
        loginIcon.style.display = 'none';
        if (isDev) console.log("Lock icon hidden (initial)");
    } else {
        adminControls.style.display = 'none';
        loginForm.style.display = window.location.hash === '#admin' ? 'flex' : 'none';
        contentWrapper.classList.toggle('blur', window.location.hash === '#admin');
        body.classList.toggle('modal-open', window.location.hash === '#admin');
        document.body.style.overflow = window.location.hash === '#admin' ? 'hidden' : 'auto';
        document.body.style.height = window.location.hash === '#admin' ? '100vh' : 'auto';
        loginIcon.style.display = 'block';
        if (isDev) console.log("Lock icon shown (initial)");
    }
    const handleLogoutClick = async (event)=>{
        event.stopPropagation();
        if (isDev) console.log('Logout button clicked');
        try {
            await supabaseClient.auth.signOut();
            window.location.hash = '';
            if (isDev) console.log('Logout successful');
        } catch (error) {
            if (isDev) console.error('Logout failed:', error);
            alert('Logout failed. Please try again.');
        }
    };
    // Initial logout button setup
    const setupLogoutListener = ()=>{
        logoutBtn = document.getElementById('logout-btn'); // Refresh reference
        if (logoutBtn) {
            logoutBtn.removeEventListener('click', handleLogoutClick); // Prevent duplicates
            logoutBtn.addEventListener('click', handleLogoutClick);
            if (isDev) console.log('Logout listener attached');
        } else if (isDev) console.warn('Logout button not found in DOM');
    };
    setupLogoutListener();
    // Setup projects and highlight sequentially
    await setupProjects(contentWrapper, isAdmin, supabase1);
    if (!highlightApplied) {
        await setupFragmentHighlighting(); // Await to ensure DOM is ready
        highlightApplied = true;
    }
    // Enhanced visibilitychange handler
    document.addEventListener('visibilitychange', ()=>{
        if (document.visibilityState === 'visible') {
            if (isDev) console.log('Tab regained focus, resetting...');
            setTimeout(()=>{
                setupLogoutListener(); // Reset logout listener
                // Reset project click handlers
                projectClickHandlers.forEach(({ handler }, projectId)=>{
                    const freshElement = document.querySelector(`#${CSS.escape(projectId)} .project-image-container`);
                    const overlay = document.querySelector(`#overlay${CSS.escape(projectId)}`);
                    if (freshElement && overlay) {
                        freshElement.removeEventListener('click', handler);
                        freshElement.addEventListener('click', (event)=>{
                            event.stopPropagation();
                            handler(event);
                        });
                        overlay.style.display = 'none';
                        if (isDev) console.log(`Reattached click listener for project: ${projectId}`);
                    } else if (isDev) console.warn(`Project element or overlay not found for ID: ${projectId}`);
                });
                // Force UI reset
                document.querySelectorAll('.overlay-container').forEach((overlay)=>{
                    overlay.style.display = 'none';
                    overlay.querySelector('.enlarged-content').style.transform = 'scale(0)';
                });
                contentWrapper.classList.remove('blur');
                body.classList.remove('modal-open');
                document.body.style.overflow = 'auto';
                document.body.style.height = 'auto';
                document.body.style.pointerEvents = 'auto';
                // Force DOM reflow
                document.body.style.display = 'none';
                document.body.offsetHeight;
                document.body.style.display = '';
                window.dispatchEvent(new Event('resize'));
                window.dispatchEvent(new Event('scroll'));
                if (isDev) console.log('Tab reset complete');
            }, 100);
        }
    });
    // Auth state change with debouncing
    let lastUser = user ? JSON.stringify(user) : null;
    let lastIsAdmin = isAdmin; // Track last isAdmin state //
    let authTimeout;
    supabase1.auth.onAuthStateChange(async (event, session)=>{
        clearTimeout(authTimeout);
        authTimeout = setTimeout(async ()=>{
            const updatedUser = session?.user;
            let updatedIsAdmin = false;
            if (updatedUser) {
                const { data: userProfile } = await supabase1.from('users').select('is_admin').eq('id', updatedUser.id).single();
                updatedIsAdmin = userProfile?.is_admin;
            }
            if (isDev) console.log("User (onAuthStateChange):", updatedUser, "isAdmin:", updatedIsAdmin);
            const updatedUserString = updatedUser ? JSON.stringify(updatedUser) : null;
            if (updatedUserString !== lastUser || updatedIsAdmin !== lastIsAdmin) {
                if (isDev) console.log("User state or admin status changed, refreshing projects...");
                lastUser = updatedUserString;
                lastIsAdmin = updatedIsAdmin; //
                await setupProjects(contentWrapper, updatedIsAdmin, supabase1);
                if (!highlightApplied) {
                    await setupFragmentHighlighting();
                    highlightApplied = true;
                }
            } else if (isDev) console.log("No significant user state change, skipping setupProjects");
             //
            if (updatedUser) {
                adminControls.style.display = updatedIsAdmin ? 'block' : 'none';
                loginForm.style.display = 'none';
                contentWrapper.classList.remove('blur');
                body.classList.remove('modal-open');
                document.body.style.overflow = 'auto';
                document.body.style.height = 'auto';
                loginIcon.style.display = 'none';
                if (isDev) console.log("Lock icon hidden (onAuthStateChange)");
                setupLogoutListener(); // Ensure logout listener persists
            } else {
                adminControls.style.display = 'none';
                loginForm.style.display = window.location.hash === '#admin' ? 'flex' : 'none';
                contentWrapper.classList.toggle('blur', window.location.hash === '#admin');
                body.classList.toggle('modal-open', window.location.hash === '#admin');
                document.body.style.overflow = window.location.hash === '#admin' ? 'hidden' : 'auto';
                document.body.style.height = window.location.hash === '#admin' ? '100vh' : 'auto';
                loginIcon.style.display = 'block';
                if (isDev) console.log("Lock icon shown (onAuthStateChange)");
            }
        }, 200); // Debounce to prevent rapid re-runs
    });
    document.getElementById('login-submit').addEventListener('click', async ()=>{
        const email = document.getElementById('email').value;
        const password = document.getElementById('password').value;
        const { error } = await supabase1.auth.signInWithPassword({
            email,
            password
        });
        if (error) {
            document.getElementById('login-error').style.display = 'block';
            console.error("Login failed:", error.message);
        } else {
            window.location.hash = '';
            loginForm.style.display = 'none';
            contentWrapper.classList.remove('blur');
            body.classList.remove('modal-open');
            document.body.style.overflow = 'auto';
            document.body.style.height = 'auto';
        }
    });
    document.getElementById('login-cancel').addEventListener('click', ()=>{
        window.location.hash = '';
        loginForm.style.display = 'none';
        contentWrapper.classList.remove('blur');
        body.classList.remove('modal-open');
        document.body.style.overflow = 'auto';
        document.body.style.height = 'auto';
    });
    document.getElementById('logout-btn').addEventListener('click', async ()=>{
        await supabase1.auth.signOut();
        window.location.hash = '';
    });
    window.addEventListener('hashchange', async ()=>{
        const { data: session } = await supabase1.auth.getSession();
        const user = session?.user;
        if (!user && window.location.hash === '#admin') {
            loginForm.style.display = 'flex';
            contentWrapper.classList.add('blur');
            body.classList.add('modal-open');
            document.body.style.overflow = 'hidden';
            document.body.style.height = '100vh';
        } else {
            loginForm.style.display = 'none';
            contentWrapper.classList.remove('blur');
            body.classList.remove('modal-open');
            document.body.style.overflow = 'auto';
            document.body.style.height = 'auto';
        }
    });
    if (loginIcon) loginIcon.addEventListener('click', async ()=>{
        const { data: session } = await supabase1.auth.getSession();
        if (!session?.user) {
            window.location.hash = '#admin';
            loginForm.style.display = 'flex';
            contentWrapper.classList.add('blur');
            body.classList.add('modal-open');
            document.body.style.overflow = 'hidden';
            document.body.style.height = '100vh';
        } else // Do nothing if the user is logged in; the lock icon should be hidden
        if (isDev) console.log("Lock icon clicked but user is already logged in; no action taken.");
    });
    const forgetPasswordLink = document.createElement('a');
    forgetPasswordLink.id = 'forget-password';
    forgetPasswordLink.textContent = 'Forgot Password?';
    forgetPasswordLink.style.color = '#ff6b6b';
    forgetPasswordLink.style.cursor = 'pointer';
    forgetPasswordLink.style.marginTop = '10px';
    forgetPasswordLink.style.display = 'block';
    loginForm.querySelector('.form-container').appendChild(forgetPasswordLink);
    forgetPasswordLink.addEventListener('click', ()=>openResetPasswordForm(supabase1));
}
// Function to open reset password form
async function openResetPasswordForm(supabase1) {
    const resetOverlay = document.createElement('div');
    resetOverlay.className = 'form-overlay';
    resetOverlay.innerHTML = `
        <div class="form-container">
            <h2>Reset Password</h2>
            <label for="reset-email">Email:</label>
            <input type="email" id="reset-email" required>
            <p id="reset-error" style="color: red; display: none;">Error resetting password</p>
            <div class="form-buttons">
                <button id="reset-submit">Send Reset Link</button>
                <button id="reset-cancel">Cancel</button>
            </div>
        </div>
    `;
    document.body.appendChild(resetOverlay);
    document.body.classList.add('modal-open');
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100vh';
    document.getElementById('reset-submit').addEventListener('click', async ()=>{
        const email = document.getElementById('reset-email').value;
        if (email) {
            const { error } = await supabase1.auth.resetPasswordForEmail(email);
            if (error) {
                document.getElementById('reset-error').style.display = 'block';
                document.getElementById('reset-error').textContent = 'Error: ' + error.message;
                console.error('Password reset error:', error);
            } else {
                alert('Password reset email sent! Check your inbox.');
                document.body.removeChild(resetOverlay);
                document.body.classList.remove('modal-open');
                document.body.style.overflow = 'auto';
                document.body.style.height = 'auto';
            }
        }
    });
    document.getElementById('reset-cancel').addEventListener('click', ()=>{
        document.body.removeChild(resetOverlay);
        document.body.classList.remove('modal-open');
        document.body.style.overflow = 'auto';
        document.body.style.height = 'auto';
    });
}
function setupDarkMode(toggle, body) {
    if (localStorage.getItem('darkMode') === 'enabled') body.classList.add('dark-mode');
    toggle.addEventListener('click', ()=>{
        body.classList.toggle('dark-mode');
        localStorage.setItem('darkMode', body.classList.contains('dark-mode') ? 'enabled' : 'disabled');
    });
}
async function setupProjects(contentWrapper, isAdmin, supabase1) {
    await loadProjects(isAdmin, supabase1, ()=>{
        const addProjectBtn = document.querySelector('.add-project');
        if (addProjectBtn) {
            addProjectBtn.style.display = isAdmin ? 'flex' : 'none';
            addProjectBtn.removeEventListener('click', handleAddProjectClick);
            addProjectBtn.addEventListener('click', handleAddProjectClick);
        }
        if (isDev) console.log("Projects setup complete");
    });
    function handleAddProjectClick() {
        if (isAdmin) openAddProjectForm(isAdmin, supabase1);
    }
}
async function loadProjects(isAdmin, supabase1, callback) {
    const { data, error } = await supabase1.from('projects').select('*');
    if (error) {
        console.error("Error loading projects:", error);
        return;
    }
    const container = document.querySelector('.container');
    container.innerHTML = `<div class="add-project" style="display: ${isAdmin ? 'flex' : 'none'};"><i class="fas fa-plus"></i></div>`;
    data.forEach((project)=>{
        // Add fallback for image loading
        const img = new Image();
        img.src = project.image_url || 'images/project.jpg';
        img.onerror = ()=>{
            img.src = 'images/project.jpg'; // Fallback to default image
            if (isDev) console.log(`Failed to load image for project ${project.id}, using fallback`);
        };
        createProjectElement(project, isAdmin, supabase1);
    });
    if (callback) callback();
}
async function openAddProjectForm(isAdmin, supabase1) {
    if (!isAdmin) return;
    let imageUrl = 'images/project.jpg';
    let screenshots = [];
    const formOverlay = document.createElement('div');
    formOverlay.className = 'form-overlay';
    formOverlay.innerHTML = `
        <div class="form-container">
            <h2>Add New Project</h2>
            <label>Title:</label>
            <input type="text" id="project-title" required>
            <label>Short Description:</label>
            <input type="text" id="project-short-description" placeholder="Short description goes here...">
            <label>Image Icon:</label>
            <button id="upload-image-btn">Upload Image</button>
            <img id="preview-image" style="display:none; width:100px;">
            <label>Detailed Description:</label>
            <textarea id="project-detailed-description" placeholder="Detailed description goes here..."></textarea>
            <label>Screenshots:</label>
            <button id="upload-screenshots-btn">Upload Screenshots</button>
            <div id="preview-screenshots"></div>
            <label>Tech Stack (comma separated):</label>
            <input type="text" id="project-techstack">
            <div class="form-buttons">
                <button id="preview-project">Preview</button>
                <button id="submit-project">Submit</button>
                <button id="cancel-project">Cancel</button>
            </div>
        </div>
    `;
    document.body.appendChild(formOverlay);
    document.body.classList.add('modal-open'); // Prevent background scrolling
    // Check if content overflows and toggle scrollable class
    const formContainer = formOverlay.querySelector('.form-container');
    const checkOverflow = ()=>{
        const tolerance = 5; // Add a small tolerance (e.g., 5px) to account for minor differences
        // Use getBoundingClientRect to get the actual rendered height
        const contentHeight = formContainer.scrollHeight;
        const visibleHeight = formContainer.clientHeight;
        formContainer.classList.toggle('scrollable', contentHeight > visibleHeight + tolerance);
        // Debug logging to verify heights
        const isDev = window.location.hostname === 'localhost';
        if (isDev) console.log('scrollHeight:', contentHeight, 'clientHeight:', visibleHeight, 'scrollable:', formContainer.classList.contains('scrollable'));
    };
    setTimeout(checkOverflow, 0); // Initial check after a slight delay to ensure DOM rendering
    // Re-check on content changes (e.g., after uploads or text input)
    formOverlay.querySelectorAll('input, textarea').forEach((input)=>{
        input.addEventListener('input', ()=>requestAnimationFrame(checkOverflow));
    });
    window.addEventListener('resize', checkOverflow);
    const imageWidget = cloudinary.createUploadWidget({
        cloudName: process.env.CLOUDINARY_CLOUD_NAME,
        uploadPreset: process.env.CLOUDINARY_UPLOAD_PRESET,
        folder: 'project-images',
        sources: [
            'local',
            'url',
            'camera'
        ],
        multiple: false,
        maxFiles: 1
    }, (error, result)=>{
        const imageLoadingElement = document.getElementById('image-loading');
        const previewImageElement = document.getElementById('preview-image');
        if (result && result.event === "upload-added" && imageLoadingElement) imageLoadingElement.style.display = 'block';
        if (!error && result && result.event === "success") {
            imageUrl = result.info.secure_url;
            if (isDev) console.log('Image uploaded:', imageUrl);
            if (previewImageElement) {
                previewImageElement.src = imageUrl;
                previewImageElement.style.display = 'block';
            }
            if (imageLoadingElement) imageLoadingElement.style.display = 'none';
            requestAnimationFrame(checkOverflow);
        } else if (error) {
            console.error('Upload error:', error);
            const errorMsg = error.statusText || 'Unknown error';
            alert(`Failed to upload image: ${errorMsg}. Please try again or contact support.`);
            if (imageLoadingElement) imageLoadingElement.style.display = 'none';
        }
    });
    document.getElementById('upload-image-btn').addEventListener('click', ()=>{
        if (typeof cloudinary === 'undefined') {
            alert('Cloudinary widget failed to load. Please refresh the page and try again.');
            return;
        }
        imageWidget.open();
    });
    const screenshotWidget = cloudinary.createUploadWidget({
        cloudName: process.env.CLOUDINARY_CLOUD_NAME,
        uploadPreset: process.env.CLOUDINARY_UPLOAD_PRESET,
        folder: 'screenshots',
        sources: [
            'local',
            'url',
            'camera'
        ],
        multiple: true,
        maxFiles: 10
    }, (error, result)=>{
        if (!error && result && result.event === "success") {
            screenshots.push(result.info.secure_url);
            const isDev = window.location.hostname === 'localhost';
            if (isDev) console.log('Screenshot uploaded:', result.info.secure_url);
            const img = document.createElement('img');
            img.src = result.info.secure_url;
            img.style.width = '100px';
            document.getElementById('preview-screenshots').appendChild(img);
            // Use requestAnimationFrame to ensure the image dimensions are applied
            requestAnimationFrame(checkOverflow);
        } else if (error) {
            console.error('Upload error:', error);
            const errorMsg = error.statusText || 'Unknown error';
            alert(`Failed to upload screenshot: ${errorMsg}. Please try again or contact support.`);
        }
    });
    document.getElementById('upload-image-btn').addEventListener('click', ()=>imageWidget.open());
    document.getElementById('upload-screenshots-btn').addEventListener('click', ()=>screenshotWidget.open());
    document.getElementById('cancel-project').addEventListener('click', ()=>{
        imageWidget.close(); // Close the widget
        document.body.removeChild(formOverlay);
        document.body.classList.remove('modal-open');
        window.removeEventListener('resize', checkOverflow);
    });
    document.getElementById('submit-project').addEventListener('click', async ()=>{
        const projectData = {
            title: document.getElementById('project-title').value.trim(),
            short_description: document.getElementById('project-short-description').value.trim() || '',
            detailed_description: document.getElementById('project-detailed-description').value.trim() || '',
            tech_stack: document.getElementById('project-techstack').value.trim().split(',').map((t)=>t.trim()).filter((t)=>t),
            image_url: imageUrl,
            screenshots
        };
        if (!projectData.title) {
            alert('Please fill in the title field.');
            return;
        }
        const { data, error } = await supabase1.from('projects').insert([
            projectData
        ]).select().single();
        if (error) alert("Error saving project: " + error.message);
        else {
            createProjectElement(data, isAdmin, supabase1);
            imageWidget.close();
            document.body.removeChild(formOverlay);
            document.body.classList.remove('modal-open');
            window.removeEventListener('resize', checkOverflow);
        }
    });
    document.getElementById('preview-project').addEventListener('click', ()=>{
        previewProject(formOverlay, isAdmin, imageUrl, screenshots, supabase1);
    });
}
function previewProject(formOverlay, isAdmin, imageUrl, screenshots, supabase1) {
    const title = document.getElementById('project-title').value.trim();
    const short_description = document.getElementById('project-short-description').value.trim() || 'Short description goes here...';
    const detailed_description = document.getElementById('project-detailed-description').value.trim() || 'Detailed description goes here...';
    const tech_stack = document.getElementById('project-techstack').value.trim().split(',').map((t)=>t.trim()).filter((t)=>t);
    if (!title) {
        alert('Please fill in the title field to preview the project.');
        return;
    }
    const tempProject = {
        title,
        short_description,
        detailed_description,
        tech_stack,
        image_url: imageUrl || 'images/project.jpg',
        screenshots: screenshots || []
    };
    showPreview(tempProject, formOverlay, isAdmin, supabase1);
}
function showPreview(tempProject, formOverlay, isAdmin, supabase1) {
    const previewOverlay = createOverlayContainer(tempProject, isAdmin);
    previewOverlay.classList.add('preview-overlay');
    const controls = previewOverlay.querySelector('.controls');
    controls.innerHTML = `
        <button class="close-btn"><i class="fa-solid fa-circle-xmark"></i></button>
        <button class="save-btn"><i class="fa-solid fa-save"></i> Save</button>
        <button class="back-btn"><i class="fa-solid fa-arrow-left"></i> Back to Edit</button>
    `;
    document.body.appendChild(previewOverlay);
    formOverlay.style.display = 'none';
    previewOverlay.style.display = 'flex';
    setTimeout(()=>previewOverlay.querySelector('.enlarged-content').style.transform = 'scale(1)', 10);
    loadOverlayData(previewOverlay, tempProject);
    previewOverlay.querySelector('.save-btn').addEventListener('click', ()=>{
        saveProject(tempProject, supabase1);
        document.body.removeChild(previewOverlay);
        document.body.removeChild(formOverlay);
        document.body.classList.remove('modal-open');
    });
    previewOverlay.querySelector('.back-btn').addEventListener('click', ()=>closeOverlay(previewOverlay, ()=>{
            formOverlay.style.display = 'flex';
            document.body.classList.add('modal-open');
        }));
    previewOverlay.querySelector('.close-btn').addEventListener('click', ()=>closeOverlay(previewOverlay, ()=>{
            formOverlay.style.display = 'flex';
            document.body.classList.add('modal-open');
        }));
}
async function saveProject(projectData, supabase1) {
    const { imageFile, ...data } = projectData; // Note: imageFile isn't used in your current flow
    const promises = [];
    if (imageFile) promises.push(uploadToCloudinary(imageFile, 'project-images'));
    else promises.push(Promise.resolve(data.image_url || 'images/project.jpg'));
    return Promise.all(promises).then(async ([image_url])=>{
        data.image_url = image_url;
        const { data: newProject, error } = await supabase1.from('projects').insert([
            data
        ]).select().single();
        if (error) {
            alert("Error saving project: " + error.message);
            throw error;
        }
        createProjectElement(newProject, true, supabase1);
    }).catch((error)=>{
        console.error("Error in saveProject:", error);
        alert("Failed to save project: " + error.message);
    });
}
function createProjectElement(project, isAdmin, supabase1) {
    const container = document.querySelector('.container');
    const addProjectBtn = document.querySelector('.add-project');
    const newProject = document.createElement('div');
    newProject.className = 'project';
    newProject.id = project.id;
    newProject.innerHTML = `
        <div class="project-image-container" data-overlay="overlay${project.id}">
            <div class="loading" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: #fff;">Loading...</div>
            <img src="${project.image_url ? `${project.image_url}?q_auto,f_auto,w_300` : 'images/project.jpg?q_auto,f_auto,w_300'}" alt="${project.title}" class="project-img" loading="lazy">
            <div class="overlay">
                <h3>${project.title}</h3>
                <div class="short-description">${project.short_description || 'Short description goes here...'}</div>
            </div>
        </div>
    `;
    container.insertBefore(newProject, addProjectBtn);
    const img = newProject.querySelector('.project-img');
    const loadingSpinner = newProject.querySelector('.loading');
    // Lazy-load with Intersection Observer fallback
    if (!('loading' in HTMLImageElement.prototype)) {
        const observer = new IntersectionObserver((entries, obs)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    const img = entry.target;
                    img.src = img.dataset.src || img.src; // Use data-src if set, else src
                    obs.unobserve(img);
                }
            });
        }, {
            rootMargin: '0px 0px 200px 0px'
        });
        observer.observe(img);
    }
    img.onload = ()=>{
        if (loadingSpinner) {
            loadingSpinner.style.display = 'none';
            if (isDev) console.log(`Image loaded for project: ${project.id}`);
        }
    };
    img.onerror = ()=>{
        img.src = 'images/project.jpg?q_auto,f_auto,w_300';
        if (loadingSpinner) {
            loadingSpinner.style.display = 'none';
            if (isDev) console.log(`Image failed for project ${project.id}, using fallback`);
        }
    };
    const overlayContainer = createOverlayContainer(project, isAdmin);
    document.body.appendChild(overlayContainer);
    setupProjectInteractions(newProject, overlayContainer, project, isAdmin, supabase1);
}
function createOverlayContainer(project, isAdmin) {
    const overlayContainer = document.createElement('div');
    overlayContainer.className = 'overlay-container';
    overlayContainer.id = `overlay${project.id}`;
    overlayContainer.innerHTML = `
        <div class="enlarged-content">
            <div class="controls">
                <button class="close-btn"><i class="fa-solid fa-circle-xmark"></i></button>
                ${isAdmin ? '<button class="edit-btn" data-edit-mode="false"><i class="fa-regular fa-pen-to-square"></i></button>' : ''}
            </div>
            <div class="detailed-description">
                <h3>${project.title}</h3>
                <p class="project-detailed-text" data-placeholder="Detailed description goes here...">${project.detailed_description || 'Detailed description goes here...'}</p>
                <div class="image-icon-section" style="display:none;"></div>
                <div class="screenshots">
                    <h4>Screenshots</h4>
                    <div class="screenshot-images"></div>
                    <input type="file" class="screenshot-upload" multiple accept="image/*" style="display:none;">
                </div>
                <div class="tech-stack">
                    <h4>Tech Stack</h4>
                    <div class="tech-list"></div>
                    <input type="text" class="tech-input" placeholder="Add a technology and press Enter" style="display:none;">
                </div>
                <button class="delete-btn" style="display:none;">Delete Project</button>
            </div>
        </div>
    `;
    return overlayContainer;
}
async function setupProjectInteractions(newProject, overlayContainer, initialProject, isAdmin, supabase1) {
    let projectImageContainer = newProject.querySelector('.project-image-container');
    const handleProjectClick = async (event)=>{
        event.stopPropagation();
        if (isDev) console.log('Project image clicked for project:', initialProject.id);
        const projectId = overlayContainer.id.replace('overlay', '');
        const { data: project } = await supabaseClient.from('projects').select('*').eq('id', projectId).single();
        overlayContainer.style.display = 'flex';
        document.querySelector('.content-wrapper').classList.add('blur');
        document.body.style.overflow = 'hidden';
        setTimeout(()=>{
            overlayContainer.querySelector('.enlarged-content').style.transform = 'scale(1)';
            loadOverlayData(overlayContainer, project, false);
            if (isDev) console.log('Overlay displayed for project:', projectId);
        }, 10);
        if (isAdmin) {
            const editBtn = overlayContainer.querySelector('.edit-btn');
            editBtn.onclick = async ()=>await toggleEditMode(overlayContainer, project, supabaseClient);
        }
    };
    if (projectImageContainer) {
        projectImageContainer.removeEventListener('click', handleProjectClick);
        projectImageContainer.addEventListener('click', handleProjectClick);
        projectClickHandlers.set(initialProject.id, {
            element: projectImageContainer,
            handler: handleProjectClick,
            overlay: overlayContainer
        });
        if (isDev) console.log(`Click handler set for project: ${initialProject.id}`);
    }
}
async function toggleEditMode(overlayContainer, project, supabase1) {
    const editBtn = overlayContainer.querySelector('.edit-btn');
    const isEditMode = editBtn.getAttribute('data-edit-mode') === 'true';
    const detailedDescriptionDiv = overlayContainer.querySelector('.detailed-description');
    const titleH3 = detailedDescriptionDiv.querySelector('h3');
    const descP = detailedDescriptionDiv.querySelector('.project-detailed-text');
    let shortDescP = detailedDescriptionDiv.querySelector('.short-description-text');
    let imageIconSection = detailedDescriptionDiv.querySelector('.image-icon-section');
    const projectId = overlayContainer.id.replace('overlay', '');
    if (!isEditMode) {
        // Fetch the latest project data before entering edit mode
        if (isDev) console.log("Entering edit mode for project:", projectId);
        // Optional: Small delay to ensure DB consistency
        await new Promise((resolve)=>setTimeout(resolve, 100));
        const { data: latestProject, error } = await supabase1.from('projects').select('*').eq('id', projectId).single();
        if (error) {
            if (isDev) console.error("Error fetching latest project:", error);
            alert("Failed to load latest project data: " + error.message);
            return;
        }
        if (isDev) console.log("Latest project data from Supabase:", latestProject);
        // Entering edit mode (unchanged)
        if (!shortDescP) {
            shortDescP = document.createElement('p');
            shortDescP.className = 'short-description-text';
            shortDescP.textContent = '';
            detailedDescriptionDiv.insertBefore(shortDescP, descP);
        }
        shortDescP.setAttribute('data-placeholder', 'Short description goes here...');
        descP.setAttribute('data-placeholder', 'Detailed description goes here...');
        // shortDescP.textContent = project.short_description || '';
        // descP.textContent = project.detailed_description || '';
        if (!imageIconSection.innerHTML) imageIconSection.innerHTML = `
                <h4>Image Icon</h4>
                <img src="${project.image_url || 'images/project.jpg'}" class="current-image-icon" style="width: 100px;">
                <input type="file" class="image-icon-upload" accept="image/*">
            `;
        imageIconSection.style.display = 'block';
        titleH3.contentEditable = true;
        shortDescP.contentEditable = true;
        descP.contentEditable = true;
        const updatePlaceholder = (element)=>{
            const isEmpty = !element.textContent.trim();
            element.classList.toggle('placeholder-visible', isEmpty);
            if (isDev) console.log(`${element.className} content:`, element.textContent, 'isEmpty:', isEmpty);
        };
        const handleInput = (element)=>{
            element.addEventListener('input', ()=>updatePlaceholder(element));
            updatePlaceholder(element);
        };
        // Load data first, then set up listeners
        loadOverlayData(overlayContainer, latestProject, true);
        handleInput(shortDescP);
        handleInput(descP);
        if (isDev) console.log("Loaded data into UI:", {
            short: shortDescP.textContent,
            detailed: descP.textContent
        });
        setupTechStackEdit(overlayContainer);
        setupScreenshotsEdit(overlayContainer);
        setupImageIconEdit(overlayContainer);
        editBtn.innerHTML = '<i class="fa-solid fa-check"></i>';
        editBtn.setAttribute('data-edit-mode', 'true');
    } else {
        // Saving and exiting edit mode
        if (isDev) console.log("Saving changes for project:", projectId);
        const imageIconUpload = overlayContainer.querySelector('.image-icon-upload');
        const newImageUrl = imageIconUpload?.dataset.uploadedUrl || project.image_url;
        const shortDescText = shortDescP.innerText.trim();
        const detailedDescText = descP.innerText.trim();
        const updatedProject = {
            title: titleH3.innerText.trim(),
            short_description: shortDescText || '',
            detailed_description: detailedDescText || '',
            screenshots: Array.from(overlayContainer.querySelectorAll('.screenshot-images img')).map((img)=>img.src),
            tech_stack: Array.from(overlayContainer.querySelectorAll('.tech-tag')).map((tag)=>tag.textContent.replace('x', '').trim()),
            image_url: newImageUrl
        };
        const { data: savedProject, error } = await supabase1.from('projects').update(updatedProject).eq('id', projectId).select().single();
        if (error) {
            console.error("Error saving changes:", error);
            alert("Failed to save changes: " + error.message);
            return;
        }
        if (isDev) console.log("Changes saved to Supabase:", savedProject);
        updateProjectCard(projectId, savedProject.title, savedProject.short_description, savedProject.image_url);
        titleH3.contentEditable = false;
        shortDescP.contentEditable = false;
        descP.contentEditable = false;
        if (shortDescP && detailedDescriptionDiv.contains(shortDescP)) detailedDescriptionDiv.removeChild(shortDescP);
        if (imageIconSection && detailedDescriptionDiv.contains(imageIconSection)) imageIconSection.style.display = 'none';
        loadOverlayData(overlayContainer, savedProject, false);
        if (isDev) console.log("UI updated after save:", {
            short: descP.textContent,
            detailed: descP.textContent
        });
        editBtn.innerHTML = '<i class="fa-regular fa-pen-to-square"></i>';
        editBtn.setAttribute('data-edit-mode', 'false');
    }
}
function uploadToCloudinary(file, folder) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'my_unsigned_preset');
    formData.append('folder', folder);
    return fetch(`https://api.cloudinary.com/v1_1/dswvnxbgd/image/upload`, {
        method: 'POST',
        body: formData
    }).then((response)=>response.json()).then((result)=>result.secure_url).catch((error)=>{
        console.error("Cloudinary upload failed:", error);
        document.getElementById('login-error').style.display = 'block'; // Reuse existing error div
        document.getElementById('login-error').textContent = "Upload failed. Please try again.";
        throw error;
    });
}
function loadOverlayData(overlayContainer, project, isEditMode = false) {
    const shortDescP = overlayContainer.querySelector('.short-description-text');
    const detailedDescP = overlayContainer.querySelector('.project-detailed-text');
    if (shortDescP) {
        if (!project.short_description) {
            shortDescP.innerText = '';
            shortDescP.classList.add('placeholder-visible');
        } else {
            shortDescP.innerText = project.short_description;
            shortDescP.classList.remove('placeholder-visible');
        }
    }
    if (!project.detailed_description) {
        detailedDescP.innerText = '';
        detailedDescP.classList.add('placeholder-visible');
    } else {
        detailedDescP.innerText = project.detailed_description;
        detailedDescP.classList.remove('placeholder-visible');
    }
    const screenshotImagesDiv = overlayContainer.querySelector('.screenshot-images');
    screenshotImagesDiv.innerHTML = '';
    (project.screenshots || []).forEach((url)=>{
        const img = document.createElement('img');
        img.src = url;
        img.style.width = '100px';
        screenshotImagesDiv.appendChild(img);
        if (isEditMode) {
            const deleteBtn = document.createElement('button');
            deleteBtn.textContent = 'x';
            deleteBtn.className = 'delete-screenshot-btn';
            deleteBtn.addEventListener('click', ()=>img.remove());
            screenshotImagesDiv.appendChild(deleteBtn);
        }
    });
    const techListDiv = overlayContainer.querySelector('.tech-list');
    techListDiv.innerHTML = '';
    (project.tech_stack || []).forEach((tech)=>{
        const span = document.createElement('span');
        span.textContent = tech;
        span.className = 'tech-tag';
        techListDiv.appendChild(span);
        if (isEditMode) {
            const deleteBtn = document.createElement('button');
            deleteBtn.textContent = 'x';
            deleteBtn.className = 'delete-tech-btn';
            deleteBtn.addEventListener('click', ()=>span.remove());
            span.appendChild(deleteBtn);
        }
    });
    const imageIconSection = overlayContainer.querySelector('.image-icon-section');
    if (isEditMode && imageIconSection.innerHTML) {
        const currentImageIcon = imageIconSection.querySelector('.current-image-icon');
        currentImageIcon.src = project.image_url || 'images/project.jpg';
    }
    overlayContainer.querySelector('.screenshot-upload').style.display = isEditMode ? 'block' : 'none';
    overlayContainer.querySelector('.tech-input').style.display = isEditMode ? 'block' : 'none';
    if (isEditMode) overlayContainer.querySelector('.image-icon-upload').style.display = 'block';
    overlayContainer.querySelector('.delete-btn').style.display = isEditMode ? 'inline-block' : 'none';
}
document.addEventListener('click', function(e) {
    if (e.target.closest('.close-btn')) closeOverlay(e.target.closest('.overlay-container'));
    if (e.target.closest('.delete-btn')) {
        const overlayContainer = e.target.closest('.overlay-container');
        const projectId = overlayContainer.id.replace('overlay', '');
        deleteProject(projectId, overlayContainer, supabaseClient);
    }
});
function closeOverlay(overlayContainer, callback) {
    overlayContainer.querySelector('.enlarged-content').style.transform = 'scale(0)';
    setTimeout(()=>{
        overlayContainer.style.display = 'none';
        document.querySelector('.content-wrapper').classList.remove('blur');
        document.body.style.overflow = 'auto';
        if (callback) callback();
    }, 300);
}
function updateProjectCard(projectId, newTitle, newShortDescription, newImageUrl) {
    const projectElement = document.getElementById(projectId);
    if (projectElement) {
        const titleElement = projectElement.querySelector('.overlay h3');
        const shortDescElement = projectElement.querySelector('.overlay .short-description');
        const imageElement = projectElement.querySelector('.project-img');
        if (titleElement) titleElement.textContent = newTitle;
        if (shortDescElement) shortDescElement.textContent = newShortDescription;
        if (imageElement) imageElement.src = newImageUrl || 'images/project.jpg';
    }
}
function setupTechStackEdit(overlayContainer) {
    const techInput = overlayContainer.querySelector('.tech-input');
    techInput.addEventListener('keypress', (e)=>{
        if (e.key === 'Enter' && techInput.value.trim()) {
            addTechTagEdit(overlayContainer, techInput.value.trim());
            techInput.value = '';
        }
    });
}
function addTechTagEdit(overlayContainer, tech) {
    const techListDiv = overlayContainer.querySelector('.tech-list');
    const tag = document.createElement('span');
    tag.textContent = tech;
    tag.className = 'tech-tag';
    const deleteBtn = document.createElement('button');
    deleteBtn.textContent = 'x';
    deleteBtn.className = 'delete-tech-btn';
    deleteBtn.addEventListener('click', ()=>tag.remove());
    tag.appendChild(deleteBtn);
    techListDiv.appendChild(tag);
}
function setupScreenshotsEdit(overlayContainer) {
    const screenshotUpload = overlayContainer.querySelector('.screenshot-upload');
    const screenshotImagesDiv = overlayContainer.querySelector('.screenshot-images');
    screenshotUpload.addEventListener('change', (e)=>{
        const files = e.target.files;
        const promises = [];
        Array.from(files).forEach((file)=>{
            promises.push(uploadToCloudinary(file, 'screenshots'));
        });
        Promise.all(promises).then((urls)=>{
            urls.forEach((url)=>{
                const img = document.createElement('img');
                img.src = url;
                img.style.width = '100px';
                screenshotImagesDiv.appendChild(img);
                const deleteBtn = document.createElement('button');
                deleteBtn.textContent = 'x';
                deleteBtn.className = 'delete-screenshot-btn';
                deleteBtn.addEventListener('click', ()=>img.remove());
                screenshotImagesDiv.appendChild(deleteBtn);
            });
        }).catch((error)=>{
            console.error("Cloudinary upload failed:", error);
            alert("Failed to upload screenshots: " + error.message);
        });
    });
}
function setupImageIconEdit(overlayContainer) {
    const imageIconUpload = overlayContainer.querySelector('.image-icon-upload');
    const currentImageIcon = overlayContainer.querySelector('.current-image-icon');
    imageIconUpload.addEventListener('change', async (e)=>{
        const file = e.target.files[0];
        if (file) try {
            const uploadedUrl = await uploadToCloudinary(file, 'project-images');
            currentImageIcon.src = uploadedUrl;
            imageIconUpload.dataset.uploadedUrl = uploadedUrl; // Store the uploaded URL
        } catch (error) {
            console.error('Image upload failed:', error);
            alert('Failed to upload image. Please try again.');
        }
    });
}
async function deleteProject(projectId, overlayContainer, supabase1) {
    try {
        const { error } = await supabase1.from('projects').delete().eq('id', projectId);
        if (error) {
            console.error("Error deleting project:", error);
            alert(`Error deleting project: ${error.message}`);
            return;
        }
        document.body.removeChild(overlayContainer);
        document.getElementById(projectId).remove();
        window.location.reload();
    } catch (error) {
        console.error("Unexpected error during project deletion:", error);
        alert("An unexpected error occurred while deleting the project. Please try again.");
    }
}
async function updateProjectInStorage(projectId, updates, supabase1) {
    const { data, error } = await supabase1.from('projects').update(updates).eq('id', projectId).select().single();
    if (error) throw error;
    return data; // Return the updated project
}
function setupScrollEffects(collaborateSection) {
    function handleScroll() {
        const sectionPosition = collaborateSection.getBoundingClientRect().top;
        const screenPosition = window.innerHeight / 1.5;
        collaborateSection.classList.toggle('active', sectionPosition < screenPosition);
    }
    window.addEventListener('scroll', handleScroll);
    handleScroll();
}
async function setupFragmentHighlighting(supabase1) {
    const fragment = window.location.hash.substring(1);
    if (fragment && !highlightApplied) {
        if (isDev) console.log("Fragment detected:", fragment);
        const targetTitle = fragment.replace(/-/g, ' ').replace(/\b\w/g, (c)=>c.toUpperCase()); // "project-1" -> "Project 1"
        if (isDev) console.log("Looking for project with title:", targetTitle);
        // Preload "Project 1" image if fragment is #project-1
        if (fragment === 'project-1') {
            const { data: project } = await supabase1.from('projects').select('image_url').eq('title', 'Project 1').single();
            if (project?.image_url) {
                const preloadLink = document.createElement('link');
                preloadLink.rel = 'preload';
                preloadLink.as = 'image';
                preloadLink.href = `${project.image_url}?q_auto,f_auto,w_300`;
                document.head.appendChild(preloadLink);
                if (isDev) console.log("Preloaded image for Project 1:", preloadLink.href);
            }
        }
        await new Promise((resolve)=>setTimeout(resolve, 500)); // Wait for DOM stability
        const allProjects = document.querySelectorAll('.project');
        let targetProject = null;
        allProjects.forEach((project)=>{
            const titleElement = project.querySelector('.overlay h3');
            const projectTitle = titleElement ? titleElement.textContent.trim() : '';
            if (projectTitle === targetTitle) targetProject = project;
        });
        if (targetProject) {
            if (isDev) console.log("Highlighting project with ID:", targetProject.id);
            targetProject.classList.add('highlighted');
            document.querySelectorAll('.project').forEach((p)=>{
                if (p.id !== targetProject.id) p.style.filter = 'blur(5px)';
            });
            targetProject.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            });
            await new Promise((resolve)=>{
                setTimeout(()=>{
                    targetProject.classList.remove('highlighted');
                    document.querySelectorAll('.project').forEach((p)=>p.style.filter = '');
                    if (isDev) console.log("Highlight removed from ID:", targetProject.id);
                    resolve();
                }, 3000);
            });
            highlightApplied = true;
        } else if (isDev) console.warn("No project found with title:", targetTitle);
    } else if (isDev) console.log("No fragment or highlight already applied, skipping...");
}
function redirectToHome() {
    window.location.href = 'index.html';
}

//# sourceMappingURL=projects.75682171.js.map
